import { forwardRef } from 'react';

import type { IconProps } from './types';

export const StakeholderIcon = forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
    fill="#909090"
    ref={forwardedRef}
    {...props}
  >
    <path d="M224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128S96 198.7 96 128 153.3 0 224 0zm-14.9 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2h39.5c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.8c77.2 12.4 136.3 78.6 136.3 158.2 0 17-13.8 30.7-30.7 30.7H30.7C13.8 510.2 0 496.5 0 479.5c0-79.6 59.1-145.8 136.3-158.2l39.5 161.8 33.4-123.9z" />
  </svg>
));
StakeholderIcon.displayName = 'StakeholderIcon';
